import { Outlet } from "react-router-dom";
import { PageProps } from "../../models/routing.model";

const CallCenter = (props: PageProps) => {
	return <Outlet />;
};

export default CallCenter;
